import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";

import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";

import {
  ICreateUnitPartition,
  IExportUnitPartitionExcel,
  IUpdateUnitPartition,
} from "../../models/unit-partition/request";
import { IUnitPartition, IUnitPartitionDetails } from "../../models/unit-partition/response";
import { IUnitPartitionQuery } from "../../models/unit-partition/query";

class UnitPartitionService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllUnitPartitions = (query: IUnitPartitionQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<IUnitPartition>>({
      path: `/unit-partitions`,
      method: "GET",
      query,
      ...params,
    });

  getUnitPartition = (id: number, params?: RequestParams) =>
    this.http.request<IUnitPartitionDetails>({
      path: `/unit-partitions/${id}`,
      method: "GET",
      ...params,
    });

  createUnitPartition = (data: ICreateUnitPartition, params?: RequestParams) =>
    this.http.request<IUnitPartition>({
      path: "/unit-partitions",
      method: "POST",
      body: data,
      ...params,
    });

  updateUnitPartition = (id: number, data: IUpdateUnitPartition, params?: RequestParams) =>
    this.http.request<IUnitPartition>({
      path: `/unit-partitions/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteUnitPartition = (id: number, params?: RequestParams) =>
    this.http.request<IUnitPartition>({
      path: `/unit-partitions/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (data: IExportUnitPartitionExcel, query: IUnitPartitionQuery) =>
    axios.post(` ${process.env.REACT_APP_BASE_API_URL}/unit-partitions/export`, data, {
      headers: {
        authorization: `Bearer ${
          localStorage.getItem(ACCESS_TOKEN) ||
          sessionStorage.getItem(ACCESS_TOKEN)
        }`,
        "Content-Type": "application/json",
        "accept-language": `${
          localStorage.getItem(LANGUAGE_CODE) ??
          process.env.REACT_APP_DEFAULT_LANGUAGE
        }`,
      },
      params: query,
      responseType: "arraybuffer",
    });
}

export default UnitPartitionService;
